/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_BoostInputs */

const en_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 credits for EUR 9.99 (one-time payment)`)
};

const de_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 Credits fuer EUR 9,99 (einmalige Zahlung)`)
};

const fr_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost : 60 credits pour EUR 9,99 (paiement unique)`)
};

const es_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 creditos por EUR 9,99 (pago unico)`)
};

const it_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 crediti a EUR 9,99 (pagamento unico)`)
};

const nl_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 credits voor EUR 9,99 (eenmalige betaling)`)
};

const pl_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 kredytow za EUR 9,99 (platnosc jednorazowa)`)
};

const fi_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 krediittiä hintaan EUR 9,99 (kertamaksu)`)
};

const da_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 credits for EUR 9,99 (engangsbetaling)`)
};

const sv_agb_credit_packs_boost = /** @type {(inputs: Agb_Credit_Packs_BoostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost: 60 krediter for EUR 9,99 (engangsebetalning)`)
};

/**
* | output |
* | --- |
* | "Boost: 60 credits for EUR 9.99 (one-time payment)" |
*
* @param {Agb_Credit_Packs_BoostInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_boost = /** @type {((inputs?: Agb_Credit_Packs_BoostInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_BoostInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_boost(inputs)
	if (locale === "fr") return fr_agb_credit_packs_boost(inputs)
	if (locale === "es") return es_agb_credit_packs_boost(inputs)
	if (locale === "it") return it_agb_credit_packs_boost(inputs)
	if (locale === "nl") return nl_agb_credit_packs_boost(inputs)
	if (locale === "pl") return pl_agb_credit_packs_boost(inputs)
	if (locale === "fi") return fi_agb_credit_packs_boost(inputs)
	if (locale === "da") return da_agb_credit_packs_boost(inputs)
	if (locale === "sv") return sv_agb_credit_packs_boost(inputs)
	return en_agb_credit_packs_boost(inputs)
});